import IssuePage from '@diziner/IssuePage';
import Ajax from '@diziner/Utils/Ajax';
import { Settings } from '@diziner/Settings';
import Logger from '@diziner/Logger';
import PubSub from 'pubsub-js';
// import * as PageTransitions from '@diziner/../libraries/pagetransitions';
import PreLoadIndicator from '@diziner/Components/Issue/PreLoadIndicator';
import NavigationMenu from '@diziner/NavigationMenu';
import PageTransitions from '@diziner/PageTransitions';
import { Events } from '@diziner/Events';
import ScrollProgressIndicator from '@diziner/Components/Issue/ScrollProgressIndicator';
import Swipe, { SwipeEventDirection } from '@diziner/Utils/Swipe';
import { ElementQueries } from 'css-element-queries';
export class IssueVariables {
    constructor(vars) {
        Object.assign(this, vars);
    }
    set previousPageIndex(value) {
        this._previousPageIndex = value;
    }
    get currentPageIndex() {
        return this._currentPageIndex;
    }
    set currentPageIndex(value) {
        if (value !== this._currentPageIndex) {
            this._currentPageIndex = value;
            Events.Issue.UpdatePageIndex.publish(value);
            return;
        }
        this._currentPageIndex = value;
    }
    get freshLoad() {
        return this._freshLoad;
    }
    set freshLoad(value) {
        this._freshLoad = value;
    }
    get navigating() {
        return this._navigating;
    }
    set navigating(value) {
        if (this._navigating === false && value === true) {
            setTimeout((function () {
                this._navigating = false;
            }).bind(this), 3000);
        }
        this._navigating = value;
    }
    get documentTitle() {
        return this._documentTitle;
    }
    set documentTitle(value) {
        this._documentTitle = value;
    }
}
export var IssueEvents;
(function (IssueEvents) {
    IssueEvents["init"] = "IssueEvent.sinit";
    IssueEvents["fetch"] = "IssueEvent.fetch";
    IssueEvents["preload"] = "IssueEvent.preload";
    IssueEvents["parseRequest"] = "IssueEvent.parseRequest";
    IssueEvents["load"] = "IssueEvent.load";
    IssueEvents["loadPageIndex"] = "IssueEvent.loadPageIndex";
    IssueEvents["updatePageIndex"] = "IssueEvent.updatePageIndex";
    IssueEvents["showPageIndex"] = "IssueEvent.showPageIndex";
})(IssueEvents || (IssueEvents = {}));
export class Issue {
    constructor(issueId) {
        this.scrollProgressIndicator = null;
        this._footer = null;
        this._asyncs = {
            fetchIssue: undefined,
            preload: undefined,
        };
        this._preLoadIndicator = null;
        this._pages = [];
        this._vars = new IssueVariables({
            previousPageIndex: -1,
            currentPageIndex: 0,
            freshLoad: true,
            navigating: false,
            documentTitle: {
                default: '',
                current: null,
                previous: null,
            },
        });
        this._issueId = issueId;
        this.navigationMenu = new NavigationMenu(this);
        this.transitions = (new PageTransitions());
        this.init();
    }
    get pages() {
        return this._pages;
    }
    set pages(pages) {
        this._pages = pages;
    }
    get issueId() {
        return this._issueId;
    }
    set issueId(value) {
        this._issueId = value;
    }
    get diziner() {
        return this._diziner;
    }
    set diziner(value) {
        this._diziner = value;
    }
    get vars() {
        return this._vars;
    }
    set vars(value) {
        this._vars = value;
    }
    /**
     * Returns whether or not this issue or any if its pages are protected by
     * login or a password.
     * @todo Implement function
     */
    requiresAuthentication() {
        return false;
    }
    /**
     * Returns whether or not this Issue in itself is protected, does not check
     * pages.
     * @todo Implement function
     */
    isIssueProtected() {
        return false;
    }
    /**
     * Checks each page on whether or not they require authentication.
     * Returns true if any page requires authentication
     */
    hasProtectedPages() {
        this.pages.forEach((page) => {
            if (page.requiresAuthentication()) {
                return true;
            }
        });
        return false;
    }
    async changeTitles(pageIndex) {
        let newTitle = '';
        if (typeof pageIndex !== 'undefined'
            && this.pages.length >= (pageIndex + 1)) {
            newTitle = this.pages[pageIndex].getPageTitle();
        }
        else {
            Logger.instance.debug(this.pages);
        }
        Promise.all([
            this.diziner.changeTitle(newTitle),
            this.diziner.changeSharingTitle(newTitle),
        ]).then(() => {
            return;
        });
    }
    /**
     * @see loadPageIndex
     * @see showPageIndex
     * @see changeTitles
     * @param index
     * @param stack
     */
    async navigateToPageIndex(index, stack = true) {
        return new Promise((resolve, reject) => {
            console.log('navigateToPageIndex:' + index);
            if (index >= (this.pages.length)
                || index < 0
                || this.vars.navigating
                || (index === this.vars.currentPageIndex
                    && this.vars.previousPageIndex >= 0)) {
                console.log('rejected');
                reject(index);
                return;
            }
            Logger.instance.group('navigateToPageIndex');
            Logger.instance.time('navigateToPageIndex');
            Logger.instance.debug('navigateToPageIndex(' + index + ',' + stack + ')');
            this.vars.navigating = true;
            Events.Issue.NavigatingToPageIndex.publish(index);
            const newUrl = document.location.origin + '/'
                + Settings.instance.issueName + '/' +
                this.pages[index].name + '/';
            this.diziner.changeUrl(newUrl);
            if (stack) {
                window.history.pushState({ index: index }, document.title, newUrl);
            }
            else {
                window.history.replaceState({ index: index }, document.title);
            }
            this.loadPageIndex(index).then(() => {
                ElementQueries.init();
                return new Promise((resolveTransition) => {
                    // setTimeout(() => {
                    this.showPageIndex(index).then(() => {
                        console.log('resolveTransition');
                        resolveTransition();
                    });
                    // }, 100);
                });
            }).then(() => {
                console.log('changeTitles');
                return this.changeTitles(index);
            }).then(() => {
                this.navigationMenu.close();
                Logger.instance.timeEnd('navigateToPageIndex');
                Logger.instance.debug(this.vars.navigating);
                Logger.instance.groupEnd();
                this.vars.navigating = false;
                Events.Issue.NavigatedToPageIndex.publish(index);
                resolve();
            });
        });
    }
    async navigateToPageId(id, stack = true) {
        const index = this.getPageIndexById(id);
        // console.log('PageIndex: ' + index + '(' + id + ')');
        if (index !== null) {
            return this.navigateToPageIndex(index, stack);
        }
    }
    /**
     * Returns pageIndex if found, null if not
     */
    getPageIndexById(id) {
        let pageNode = document.querySelector('.page-container[data-pageid="' + id + '"]');
        // console.log(pageNode);
        if (!pageNode) {
            return null;
        }
        let index = 0;
        while ((pageNode = pageNode.previousElementSibling))
            index++;
        // console.log('Index:' + index);
        // Offset of -1 for the main-menu-button
        return index - 1;
    }
    /**
     * Returns pageIndex if found, null if not
     */
    getPageIndexByName(name) {
        const id = this.getPageIdByName(name);
        if (id === null)
            return null;
        return this.getPageIndexById(id);
    }
    async navigateToPreviousPage() {
        if (this.vars.currentPageIndex === 0) {
            return;
        }
        return this.navigateToPageIndex(this.vars.currentPageIndex - 1);
    }
    async navigateToNextPage() {
        if ((this.vars.currentPageIndex + 1) >= this.pages.length) {
            return;
        }
        return this.navigateToPageIndex(this.vars.currentPageIndex + 1);
    }
    async navigateToFirstPage() {
        if (this.pages.length === 0) {
            return;
        }
        return this.navigateToPageIndex(0);
    }
    async navigateToLastPage() {
        if (this.pages.length === 0) {
            return;
        }
        return this.navigateToPageIndex(this.pages.length - 1);
    }
    async transitionToPage(index) {
        let animation;
        if (this.vars.freshLoad === true) {
            animation = Settings.instance.transitions.entry;
        }
        else if (index > this.vars.currentPageIndex) {
            animation = Settings.instance.transitions.forward;
        }
        else {
            animation = Settings.instance.transitions.back;
        }
        Logger.instance.debug('Using animation: ' + animation);
        Logger.instance.timeLog('showPageIndex', 'starting transition');
        return this.transitions.nextPage({
            animation: animation,
            showPage: (index + 1),
        });
    }
    getCurrentPage() {
        if (this.pages.length >= (this.vars.currentPageIndex + 1)) {
            return this.pages[this.vars.currentPageIndex];
        }
        return null;
    }
    onPopState(event) {
        Logger.instance.debug('popstate');
        let newPageIndex = event.state.index;
        if (newPageIndex !== null) {
            this.navigateToPageIndex(newPageIndex, false);
            return;
        }
        newPageIndex = this.getPageIndexFromLocation();
        if (newPageIndex !== null) {
            this.navigateToPageId(newPageIndex);
            return;
        }
        Logger.instance.debug(event);
    }
    /**
     * @implements loadIssue
     * @implements navigateToPageIndex
     * @protected
     */
    init() {
        Logger.instance.debug('init.start');
        // Initialize config, validate settings are there and parse them
        const loadingSvgElement = document.querySelector('.loadingpage svg.progress-circle');
        if (loadingSvgElement !== null) {
            this._preLoadIndicator =
                new PreLoadIndicator(loadingSvgElement);
        }
        const scrollProgressElement = document.querySelector('.progress-wrap > .progress-indicator');
        if (scrollProgressElement !== null) {
            this.scrollProgressIndicator =
                new ScrollProgressIndicator(scrollProgressElement);
        }
        this.initListeners();
        this.loadIssue().then(() => {
            if (this.vars.freshLoad) {
                const pageIndex = this.getPageIndexFromLocation() || 0;
                this.changeTitles(pageIndex);
                this.navigationMenu.updateMenuPosition();
                this.navigateToPageIndex(pageIndex, false).then(() => {
                    if (window.location.hash.length > 1) {
                        this.getCurrentPage()?.scrollTo(window.location.hash);
                    }
                    Logger.instance.debug('init.then');
                    this.vars.freshLoad = false;
                });
            }
        });
        Logger.instance.debug('init.end');
    }
    async loadIssue() {
        return new Promise((resolve) => {
            Logger.instance.debug('loadIssue-start');
            this._asyncs.fetchIssue = this.fetchIssue();
            PubSub.publish(IssueEvents.load);
            this._asyncs.fetchIssue.then(request => this.preload(request)).
                then(() => {
                Logger.instance.debug('loadIssue-then');
                resolve();
            });
            Logger.instance.debug('loadIssue-end');
        });
    }
    async fetchIssue() {
        return new Promise((resolve) => {
            Logger.instance.time('Issue.fetchIssue()');
            const request = Ajax.get(Ajax.appendURLQueryToURL(Settings.instance.ajaxUrl, Ajax.buildURLQuery({ parent_id: this.issueId })));
            request.then(async () => {
                Logger.instance.timeEnd('Issue.fetchIssue()');
                resolve(request);
            });
        });
    }
    async preload(request) {
        // TODO: loadingSVG
        Logger.instance.debug('preload-start');
        Logger.instance.time('preload');
        const parseRequest = this.parseRequest(request);
        parseRequest.then(() => {
            Logger.instance.debug('preload-then');
            Logger.instance.timeEnd.call('preload');
        });
        Logger.instance.debug('preload-end');
        return parseRequest;
    }
    /**
     * Loads a page based on its index, does not change the appearance in any way.
     * @param index
     * @protected
     */
    async loadPageIndex(index) {
        return new Promise((resolve) => {
            Logger.instance.debug('Issue.loadPageIndex: ' + index);
            Logger.instance.time('Issue.loadPageIndex');
            // TODO: Might want to cleanup old pages here, depending on memory usage.
            const newPageContainer = document.querySelector('div.page-container[data-pageid="' + this.pages[index].pageId + '"]');
            if (newPageContainer
                && typeof this._pages[index] !== 'undefined') {
                newPageContainer.innerHTML = this.pages[index].body;
                this.pages[index].loaded = true;
                this.pages[index].registerPageHandlers();
            }
            resolve();
            PubSub.publish(IssueEvents.loadPageIndex, index);
            Logger.instance.timeEnd('Issue.loadPageIndex');
        });
    }
    /**
     * Actually navigates to a page by its index
     * @param index
     * @protected
     */
    async showPageIndex(index) {
        const newPage = this.pages[index];
        Logger.instance.time('showPageIndex');
        const transition = this.transitionToPage(index);
        this.vars.previousPageIndex = this.vars.currentPageIndex;
        this.vars.currentPageIndex = index;
        const newPageContainer = newPage.findHtmlContainer();
        if (newPageContainer) {
            await this.pages[index].pageHandlers.
                onScrollPage.call(newPageContainer);
        }
        Logger.instance.timeLog('showPageIndex', 'initOnReadyComponents');
        if (newPage.shown === false) {
            newPage.shown = true;
        }
        const hiding = [];
        Logger.instance.timeLog('showPageIndex', 'push hiding for other pages');
        this.pages.forEach((page) => {
            if (page.pageId !== newPage.pageId) {
                hiding.push(new Promise(() => {
                    /*
                     * TODO: Not sure if hiding page-containers is the best choice.
                     * Might save some memory, but loading them at a later stage might
                     * introduce stuttering.
                     */
                    // page.findHtmlContainer()?.classList.remove('pt-page-current');
                }));
            }
        });
        Logger.instance.timeLog('showPageIndex', 'done pushing hiding for other pages');
        PubSub.publish(IssueEvents.showPageIndex, index);
        Promise.all(hiding).
            then(() => {
            Logger.instance.timeLog('showPageIndex', 'done hiding for other pages');
            Logger.instance.debug('Hidden all other pages.');
        });
        transition.then(() => {
            Logger.instance.debug('nextPageTransition done');
        });
        Logger.instance.timeEnd('showPageIndex');
        return transition;
    }
    /**
     * Returns pageId if found, null if not
     */
    getPageIdByName(name) {
        let pageId = null;
        this.pages.forEach((page) => {
            if (page.name === name) {
                pageId = page.pageId;
            }
        });
        return pageId;
    }
    initListeners() {
        window.addEventListener('popstate', this.onPopState.bind(this));
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.addEventListener('swiped', this.onSwiped.bind(this));
        new Swipe(document);
        document.getElementById('pt-main')?.
            addEventListener('touchstart', (event) => {
            if (event.touches[0].clientX < 50 ||
                event.touches[0].clientX > (window.innerWidth - 50)) {
                Logger.instance.debug('Preventing default because touchX=' + event.touches[0].clientX);
                event.preventDefault();
            }
        }, false);
        // ElementQueries.listen();
    }
    async parseRequest(request) {
        Logger.instance.time('Parsing Issue JSON');
        const json = JSON.parse(request.responseText);
        this._footer = json.footer;
        this.pages = [];
        const ajaxStyleBlock = document.getElementById('ajax-styleblock');
        if (ajaxStyleBlock !== null) {
            ajaxStyleBlock.innerHTML = json.footer;
        }
        this._preLoadIndicator?.setProgressMax(json.pages.length);
        json.pages.forEach((page, key) => {
            const newPage = new IssuePage(page.id);
            newPage.body = page.body;
            newPage.order = page.order;
            newPage.name = page.name;
            newPage.meta = page.meta;
            this.pages.push(newPage);
            this._preLoadIndicator?.setProgress(key);
        });
        Logger.instance.timeEnd('Parsing Issue JSON');
    }
    /**
     * Returns pageIndex if found, null if not
     */
    getPageIdFromLocation() {
        const pageIndex = this.getPageIndexFromLocation();
        const pageId = this.pages[pageIndex]?.pageId || 0;
        Logger.instance.debug('getPageIdFromLocation: ' + pageId);
        return pageId;
    }
    /**
     * Returns pageIndex if url mathes page, null if not
     */
    getPageIndexFromLocation() {
        let pageIndex = 0;
        const pathVars = window.location.pathname.
            split('/').
            filter((e) => {
            return e;
        });
        if (pathVars.length >= 2) {
            // if 0 or false, goes to 0
            pageIndex = this.getPageIndexByName(pathVars[1]) || 0;
        }
        return pageIndex;
    }
    onSwiped(customEvent) {
        const event = customEvent.detail;
        Logger.instance.debug(event);
        if (event.direction === SwipeEventDirection.right) {
            this.navigateToPreviousPage();
        }
        else if (event.direction === SwipeEventDirection.left) {
            this.navigateToNextPage();
        }
    }
    navigateToExternal(href, target, rel) {
        Logger.instance.debug(href +
            ' - ' + (target ?? 'null') +
            ' - ' + (rel ?? 'null'));
        // TODO: Add GA signal
        if (rel !== 'noopener' && rel !== 'noreferrer') {
            rel = null;
        }
        if (target !== null && rel === null) {
            Logger.instance.debug('window.open: 1');
            window.open(href, target);
        }
        else if (target === null && rel !== null) {
            Logger.instance.debug('window.open: 2');
            window.open(href, href, rel);
        }
        else if (target !== null && rel !== null) {
            Logger.instance.debug('window.open: 3');
            window.open(href, target, 'rel=' + rel);
        }
        else {
            Logger.instance.debug('window.location: 4');
            window.location.href = href;
        }
    }
}
export default Issue;
